/* src/pages/About.js */

import React from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./About.module.css"; // Import as a CSS Module
import aboutImage from "../assets/Images/about-us.jpg"; // Ensure this image exists

function About() {
  return (
    <PageSection title="About Tharpe Industries" cta>
      <Helmet>
        <title>About Us | Tharpe Industries</title>
        <meta
          name="description"
          content="Learn more about Tharpe Industries, your down-to-earth IT partner in Shreveport-Bossier. No tech jargon, just straightforward solutions that work."
        />
      </Helmet>

      {/* Introduction Section */}
      <div className={styles.aboutContentContainer}>
        <img
          src={aboutImage}
          alt="About Tharpe Industries"
          className={styles.aboutImage}
          loading="lazy"
        />
        <div className={styles.aboutTextContent}>
          <p>
            <strong>Hey there, I'm Austin Tharpe</strong>, and I started this company because I saw how frustrating IT services can be for local businesses. Too expensive, too complicated, and way too much tech jargon.
          </p>
          <p>
            I've spent years working with technology and realized there's a better way to do things. At Tharpe Industries, I cut through the tech-speak and focus on what matters - keeping your business running smoothly with technology that actually helps, not hinders.
          </p>
        </div>
      </div>

      {/* Why Choose Me Section */}
      <div className={styles.uspSection}>
        <h3>What Makes Me Different</h3>
        <ul>
          <li><strong>Plain English Guaranteed:</strong> I'll never talk over your head with tech jargon. If you don't understand something, I'm not doing my job right.</li>
          <li><strong>Just Me, No Middlemen:</strong> When you call, you get me - not a call center or support ticket system. Direct service from start to finish.</li>
          <li><strong>Fair Pricing:</strong> Smart use of automation and modern tools means I can keep costs down while delivering quality service.</li>
          <li><strong>Shreveport-Bossier Focused:</strong> I live here too, so I get the challenges local businesses face in our community.</li>
        </ul>
      </div>

      {/* Community Connection Section */}
      <div className={styles.personalSection}>
        <h3>Local Roots</h3>
        <div className={styles.personalContent}>
          <img
            src={require("../assets/Images/shreveport-skyline.jpg")}
            alt="Shreveport Skyline"
            className={styles.personalImage}
            loading="lazy"
          />
          <p>
            Being a Shreveport-Bossier local means I understand our area's unique business landscape. I believe our community thrives when local businesses have access to the same quality tech support as the big guys, just without the big price tag. I'm committed to helping our local businesses grow with technology that actually makes sense for their needs and budget.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default About;
